<thera-dropdown
  [defaultSelection]="selectedCorporationId"
  [options]="corporationOptions"
  (optionSelected)="onCorporationSelected($event)"
></thera-dropdown>
